module.exports = __webpack_public_path__ + "img/tune-up-child.52c000af.png";